export default __webpack_public_path__ + "static/media/icon_checkbox_off.88a693e0.svg";